import EventCard from './EventCard';
import EventCardSkeleton from './EventCardSkeleton';

export { EventCardSkeleton };
export default EventCard;
